import React from 'react';
import { withRouter } from 'react-router-dom';

import { componentAPI } from 'api/requests';

import Header from './Header';
import GeneralInformation from './GeneralInformation';
import NotesSection from './NotesSection';
import ContactInformation from './ContactInformation';
import ChangeStatus from './ChangeStatus';
import FilePicker from 'Components/FilePicker';
import ApplicationActions from 'Components/ApplicationActions';
import FamilyInfo from './FamilyInfo'

@withRouter
export default class DetailsApplication extends React.Component {
  _handleBackClick = () => {
    const {user} = this.props;

    user.goBack();
  };

  render() {
    const {
      user,
      match,
      applicationStatus,
      componentType,
      componentTypeFieldValues,
      description,
      submissionDate,
      notes,
      submittedBy,
      componentTestReports,
      changeStatus,
      availableActions,
      requestInProcess,
      categories,
      family
    } = this.props;
    const {applicationId} = match.params;

    if (requestInProcess) {
      return (
        <section className='scene__scene-wrapper'>
          <section className='scene__content-wrapper detailsScene__content-wrapper'>
            <Header user={user} applicationId={applicationId} loadInProgress={true} />
            <div className='ect-spinner _width_pc_100 _height_120'>
              <div className='ect-spinner__image' />
            </div>
          </section>
        </section>
      );
    } else {
      return (
        <section className='scene__scene-wrapper'>
          <section
            className={`scene__content-wrapper detailsScene__content-wrapper ${applicationStatus.toLowerCase()}`}
          >
            <Header applicationStatus={applicationStatus} applicationId={applicationId} user={user} />
            <GeneralInformation
              type={componentType}
              category={categories.find(cat => cat.id === componentType.categoryId)}
              componentTypeFieldValues={componentTypeFieldValues}
              description={description}
              submissionDate={submissionDate}
              id={applicationId}
            />
            <NotesSection notes={notes} />
            <ContactInformation submittedBy={submittedBy} />
            {!!family && <FamilyInfo family={family} user={user} />}
            {!!componentTestReports.length && (
              <section className='scene_section'>
                <FilePicker
                  isEditable={false}
                  sectionHeaderClassName='scene_section-header'
                  notEditableStateSectionHeader='Uploaded Component-specific documents'
                  infoMessage='Test reports in this section are component-specific and available for this component only'
                  files={componentTestReports}
                  listSectionId='individual_test_reports'
                  httpParams={{
                    currentId: applicationId,
                    currentMethod: componentAPI.downloadReport,
                    fileIdFieldName: 'id',
                  }}
                />
              </section>
            )}
            <ChangeStatus
              availableActions={availableActions}
              applicationId={applicationId}
              changeStatus={changeStatus}
              user={user}
            />
            <ApplicationActions backButtonLabel='Back' backButtonAction={this._handleBackClick} />
          </section>
        </section>
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/Scenes/ComponentManufacturer/Application/Details/index.jsx